(function () {
  var dataEl = document.getElementById('OptionUrlVariants');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var PARAM = 'option';
  // Shopify 검색/추천 결과 클릭 시 붙는 추적 파라미터 (페이지 로드 시 이미 기록되므로 주소창에서 제거)
  var STRIP_PARAMS = ['_pos', '_sid', '_ss', '_psq', '_fid', '_v'];
  var byId = {};
  var byTitle = {};
  variants.forEach(function (v) {
    byId[String(v.id)] = v;
    byTitle[v.title] = v;
  });
  // 옵션이 없는 상품(Default Title)은 ?option= 을 붙이지 않음
  var isDefaultOnly = variants.length === 1 && variants[0].title === 'Default Title';

  // ?variant=ID 는 ?option=옵션명 으로 바꾸고, Shopify 검색 추적 파라미터는 제거 (바뀐 게 없으면 null)
  function toOptionUrl(urlLike) {
    var url = new URL(urlLike, location.href);
    var changed = false;

    var vid = url.searchParams.get('variant');
    if (vid && byId[vid]) {
      url.searchParams.delete('variant');
      if (!isDefaultOnly) url.searchParams.set(PARAM, byId[vid].title);
      changed = true;
    }

    STRIP_PARAMS.forEach(function (key) {
      if (url.searchParams.has(key)) {
        url.searchParams.delete(key);
        changed = true;
      }
    });

    return changed ? url.pathname + url.search + url.hash : null;
  }

  // 1. history.replaceState / pushState 가로채기
  ['replaceState', 'pushState'].forEach(function (fn) {
    var orig = history[fn];
    history[fn] = function (state, title, url) {
      if (url != null) {
        var rewritten = toOptionUrl(url);
        if (rewritten) url = rewritten;
      }
      return orig.call(this, state, title, url);
    };
  });

  // 2. 진입 시 주소창 정리: ?variant= → ?option=, Shopify 검색 추적 파라미터 제거 (UTM 등 다른 파라미터는 유지)
  var initial = toOptionUrl(location.href);
  if (initial) history.replaceState(history.state, '', initial);

  // 3. ?option= 으로 진입한 경우 옵션 복원
  var params = new URLSearchParams(location.search);
  var optionValue = params.get(PARAM);
  if (!optionValue || params.has('variant')) return;

  var target = byTitle[optionValue];
  if (!target) return;

  function restore() {
    // 커스텀 옵션 상품(data-update-url="false")은 select_option.js가 복원하므로 제외
    var info = document.querySelector('product-info[data-update-url="true"]');
    if (!info) return;
    var picker = info.querySelector('variant-selects');
    if (!picker) return;

    var groups = picker.querySelectorAll('.product-form__input');
    var changedInput = null;

    target.options.forEach(function (value, i) {
      var group = groups[i];
      if (!group) return;

      // 버튼(라디오) 형태
      var radio = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (el) {
        return el.value === value;
      });
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          changedInput = radio;
        }
        return;
      }

      // 드롭다운(select) 형태 — Dawn은 option[selected] 속성으로 선택값을 읽으므로 속성까지 변경
      var select = group.querySelector('select');
      if (select) {
        Array.prototype.forEach.call(select.options, function (opt) {
          if (opt.value === value) {
            if (!opt.selected) changedInput = select;
            opt.selected = true;
            opt.setAttribute('selected', 'selected');
          } else {
            opt.removeAttribute('selected');
          }
        });
      }
    });

    // 모든 옵션을 맞춘 뒤 change 이벤트 한 번만 발생 → Dawn이 가격/이미지/재고/폼을 업데이트
    if (changedInput) changedInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();